import { render } from "./hprice.vue?vue&type=template&id=2f96a04a&scoped=true"
const script = {}

import "./hprice.vue?vue&type=style&index=0&id=2f96a04a&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f96a04a"]])

export default __exports__